import React, { useEffect, useState } from 'react';
import { IntlProvider } from 'react-intl';

import { DEFAULT_LOCALE, getMessages, resolveLocale, type SupportedLocale } from 'intl/locale';

interface Props {
  readonly children: React.ReactNode;
}

const AppIntlProvider: React.FC<Props> = ({ children }) => {
  const [locale, setLocale] = useState<SupportedLocale>(DEFAULT_LOCALE);

  useEffect(() => {
    void resolveLocale().then(setLocale);
  }, []);

  return (
    <IntlProvider defaultLocale={DEFAULT_LOCALE} locale={locale} messages={getMessages(locale)}>
      {children}
    </IntlProvider>
  );
};

export default AppIntlProvider;
